<mat-card>
  <mat-card-title>
    <p8-layout-settings-header [titlePath]="['Ajouter / Supprimer un gestionnaire pour ce formulaire']" [iconRacine]="'supervisor_account'"></p8-layout-settings-header>
  </mat-card-title>
  <mat-card-subtitle>{{data?.nom}}</mat-card-subtitle>

  <mat-card-content>
    <app-search-ldap fxFlex="90"
                     [ldapDisplayProperty]="'cn,mail'"
                     [removeDiatrics]="true"
                     [placeHolder]="'Rechercher une personne puis la sélectionner pour l\'ajouter...'"
                     [scope]="scope"
                     [title]="false"
                     [defaultScopes]="defaultScopes"
                     [scopesToDisplay]="scopesToDisplay"
                     (ldapUserSelected)="onSelectIndiv($event)">
    </app-search-ldap>
  </mat-card-content>

  <mat-card-content>
    <app-gestionnaires-list fxFlex="75" [formModel]="data" [canDelete]="true"
                            (onFormLoaded)="formLoaded($event)"></app-gestionnaires-list>
  </mat-card-content>

  <mat-card-footer>
    <mat-dialog-actions align="end">
      <mat-progress-bar *ngIf="onProcess" [mode]="'indeterminate'"></mat-progress-bar>
      <button (click)="onClose()"
              [disabled]="onProcess"
              mat-raised-button
              color="primary"
              type="button">
        Fermer
      </button>
    </mat-dialog-actions>
  </mat-card-footer>
</mat-card>
